import React from "react";
import PropTypes from "prop-types";

import { Icon } from ".";
import { useTrans } from "../hooks";

/**
 * The report story card.
 */
const PremiumPicksCard = ({ isCurrentPick, isUpcomingPick }) => {
  const { trans } = useTrans();

  if (!isCurrentPick && !isUpcomingPick) return null;

  let cardDate = new Date(
    new Date().getFullYear(),
    new Date().getMonth() + 1,
    1,
    0,
    0,
    0,
    0
  );

  if (isCurrentPick) {
    cardDate.setDate(cardDate.getDate() - 1);
  }

  return (
    <div>
      <a className="card on-navigate" href="/catalog/premiumpicks" tabIndex="0">
        <div className="card__action-icon-premium-content">
          <Icon
            name="zap"
            size="12"
            className="card__action-icon"
            color="ds-base-4-accent"
            fill
          />
        </div>
        <div className="card__label column">
          <span id="content-title" className="card__title">
            {trans("Premium Picks")}
          </span>
          <div className="card__description md">
            {isCurrentPick
              ? trans("Free for subscribers until")
              : trans("Free for subscribers on")}{" "}
            {cardDate.toLocaleString("default", {
              month: "short",
              day: "numeric"
            })}
          </div>
        </div>
        <Icon className="card__nav-icon" name="chevRight" size="24" />
      </a>
    </div>
  );
};

PremiumPicksCard.propTypes = {
  isCurrentPick: PropTypes.bool,
  isUpcomingPick: PropTypes.bool
};

export default PremiumPicksCard;
